import moment from "moment";
import "moment/locale/vi";
import "moment/locale/zh-cn";
import enUS from "ant-design-vue/es/date-picker/locale/en_US";
import viVN from "ant-design-vue/es/date-picker/locale/vi_VN";
import zhCN from "ant-design-vue/es/date-picker/locale/zh_CN";

const locale = window.AppLocale || "vi";
const momentLocales = { en: "en", vi: "vi", zh: "zh-cn" };
const datePickerLocales = { en: enUS, vi: viVN, zh: zhCN };

moment.locale(momentLocales[locale] || momentLocales.vi);

export const datePickerLocale = datePickerLocales[locale] || datePickerLocales.vi;
